<template>
    <div class="h-full border-r overflow-y-scroll">

        <sub-menu
            :links="links"
            header="Disputes & Litigation"
        ></sub-menu>

    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import SubMenu from '@/components/menu/SubMenu.vue'
import menus from '@/utils/menus'

export default defineComponent({
    name: 'DisputesSidebar',
    components: {
        SubMenu
    },
    setup() {
        const { disputesSidebarLinks } = menus();

        return {
            links: disputesSidebarLinks,
        }
    }  
})
</script>